module.exports = __webpack_public_path__ + "media/components/assets/images/makeyourdream/kakao_share_thumb-cc106a860adbc007472ea5ccc14ef79c.png";